import {Component, Input, OnDestroy, OnInit, input} from '@angular/core';
import * as fromApp from '../../../store/app.reducers';
import {Chart} from 'angular-highcharts';
import {Observable, Subscription} from 'rxjs';
import {ActivatedRoute, Params} from '@angular/router';
import {Store} from '@ngrx/store';

import * as fromProfile from '../../store/profile.reducers';
import * as ProfileActions from '../../store/profile.actions';
import * as PostActions from '../../post/store/post.actions';
import * as DemoActions from '../../../demo/store/demo.actions';

import {ChartService} from '../../chart.service';
import {UserService} from '../../../user/user.service';
import {HelperService} from '../../../share/helper.service';

@Component({
    selector: 'app-interaction-analyze',
    templateUrl: './interaction-analyze.component.html',
    styleUrls: ['./interaction-analyze.component.scss'],
    standalone: false
})
export class InteractionAnalyzeComponent implements OnInit, OnDestroy {

  readonly type = input<number>(undefined);
  readonly auditType = input<'profile' | 'demo'>(undefined);
  @Input() id: number;
  code: string;
  initData: boolean;
  profileState: Observable<fromProfile.State>;
  routeSubscription: Subscription;
  profileSubscription: Subscription;
  chartsMedia: Chart[];
  adminCharts: boolean;
  sectionName = {
    like: '',
    comment: ''
  };

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private userService: UserService,
    private helperService: HelperService
  ) { }

  getAuditType(): 'profile' | 'demo' {
    const auditType = this.auditType();
    if (auditType === undefined) {
      return 'profile';
    }
    return auditType;
  }

  getAuditActions() {
    const auditType = this.auditType();
    if (auditType === undefined || auditType === 'profile') {
      return ProfileActions;
    } else if (auditType === 'demo') {
      return DemoActions;
    }
  }

  ngOnInit() {
    this.initData = false;
    this.sectionName.like = this.helperService.generateRandomString(10);
    this.sectionName.comment = this.helperService.generateRandomString(10);

    this.adminCharts = false;
    this.profileState = this.store.select(this.getAuditType());
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        if (params.id !== undefined) {
          this.id = params.id;
        }
        this.code = params.code;
      }
    );
    this.profileSubscription = this.store.select(this.getAuditType()).subscribe(
      (state: fromProfile.State) => {
        const auditType = this.auditType();
        if (state.audit !== null && state.audit.status !== 0 && !this.initData && auditType === 'profile') {
          this.initData = true;
          if (this.id !== undefined) {
            if (+this.type() === 1) {
              this.store.dispatch(
                new ProfileActions.GetMediaStat({
                  id: this.id,
                  params: {
                    code: this.code
                  }
                })
              );
            } else if (+this.type() === 2) {
              this.store.dispatch(
                new PostActions.GetMediaStat({
                  id: this.id
                })
              );
            }
          }
        }


        if (state.mediaStat !== null && (state.chartReload === this.getAuditActions().SET_MEDIA_STAT || auditType === 'demo')) {
          this.chartsMedia = [];
          this.chartsMedia.push(
            ChartService.getMediaTypeChart(state.mediaStat.like),
            ChartService.getMediaTypeChart(state.mediaStat.comment),
            ChartService.getMediaTypeWithOutGuestChart(state.mediaStat.like),
            ChartService.getMediaTypeWithOutGuestChart(state.mediaStat.comment)
          );
        }

      }
    );
  }

  adminChartsToggle() {
    this.adminCharts = !this.adminCharts;
  }

  isAdmin(): Observable<boolean> {
    return this.userService.isAdmin();
  }

  getLevel(percent: number) {
    return ChartService.conditionLevelBlue(percent);
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
  }

}
